<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
			<b-row>
                <b-col md="5" sm="12" >
					<div class="custom-card-dashboard gold-card">
						<div class="d-flex justify-content-between align-items-start">
							<div class="d-flex align-items-center">
								<div class="cash-balance">
									<p class="mb-1">Harga Emas Sekarang (Gold Price)</p>
									<h4 class="nominal mb-0">
										{{ 'Rp. '+$helper.addThousandSeparator(hargaEmasSekarang) }}
									</h4>
									<span class="small text-muted">Per 24 karat per gram</span>
									<div class="d-flex align-items-center mt-1">
										<span class="small text-muted mr-2">Persen Value</span>
										<span class="status-box-md status-box-success">{{ dataPercentageValue }}%</span>
									</div>
									<b-button class="d-block mt-2 history-emas-btn" variant="pgiBtn" @click="openHistoryHargaEmas()">
										Riwayat
									</b-button>
								</div>
							</div>
							<b-button variant="pgiBtn" @click="openEditHargaEmas()">
								<i class="fa fa-edit mr-1"></i>
								Ubah
							</b-button>
						</div>
					</div>
                </b-col>
			</b-row>

			<b-card>
				<template v-slot:header>
					<h5>LTV Emas </h5>
				</template>
				<b-modal 
				hide-footer 
				id="modal-add-ltv" 
				:title="newLtv.nama ? 'Edit ' + newLtv.nama : 'Tambah LTV Emas'" 
				:no-close-on-backdrop="isLoadingSubmit"
				:no-close-on-esc="isLoadingSubmit"
        :hide-header-close="isLoadingSubmit"
				>

					<b-form @submit.prevent="addLtv()">
						<div v-if="newLtv.isEdit !== true" class="form-content-wrapper mb-0">
							<h6 class="">Jenis</h6>
							<b-form-select v-model="newLtv.jenisId" :options="optJenisEmas.map(item => ({ value: item.id, text: item.name }))">
								<template #first>
									<b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
								</template>
							</b-form-select>
						</div>
						<div class="form-content-wrapper mb-0 mt-4" v-if="newLtv.isEdit !== true">
							<h6 class="">Merk</h6>
							<StateInputHandler
								:isLoading="stateMerkBarang.isLoading"
								:error="stateMerkBarang.error"
								errorMessage="Gagal memuat merk."
								@retry="fetchMerkBarangByJenis"
							>
							<multiselect v-model="newLtv.merk" :disabled="!newLtv.jenisId || stateMerkBarang.data.length == 0" :options="stateMerkBarang.data"
									:internal-search="true" :allow-empty="false" deselect-label="" select-label="" label="name"
									track-by="id" placeholder="-- Please select an option --" />
							
								<EmptyStateInput v-if="newLtv.jenisId && stateMerkBarang.data.length == 0" />
							</StateInputHandler>
							<span class="text-muted smallText">Kosongkan merk apabila anda ingin melakukan setting LTV umum untuk jenisnya. LTV umum jenis akan digunakan apabila merk yang disimulasikan / digadaikan tidak memiliki LTV spesifik.</span>
						</div>
						<div class="form-content-wrapper mb-0 mt-4">
							<h6 class="">Persentase </h6>
							<b-form-group>
								<b-input-group append="%">
									<b-form-input v-model="newLtv.persen" required></b-form-input>
								</b-input-group>
							</b-form-group>
						</div>
						</b-form>
						<div class="form-wrapper-btn">
							<b-button class="mr-2" variant="primary" @click="addLtv(true)" :disabled="isLoadingSubmit">
								<b-spinner small v-if="isLoadingSubmit" variant="secondary" type="grow" label="Spinning"></b-spinner>
								Simpan
							</b-button>
							<b-button variant="secondary" @click="$bvModal.hide('modal-add-ltv')" :disabled="isLoadingSubmit">Batal</b-button>
						</div>
					</b-modal>
				<div class="ltv-emas form-content-wrapper">
					<b-form>
					<b-button variant="pgiBtn" class="" @click="showAddLtv">
						<i class="fa fa-plus"></i>{{ (isBusy) ? 'Loading...' : ' Tambah LTV' }}
					</b-button>
					</b-form>

					<b-table
					:items="ltvList"
					:fields="fieldsLtv"
					:busy="isLoadingLtv"
					striped
					hover
					bordered
					class="mt-4"
					>
						<template v-slot:table-busy>
							<div class="text-center text-primary my-2">
								<b-spinner class="align-middle"></b-spinner>
							</div>
						</template>
					<template #cell(aksi)="row">
						<b-button size="sm" class="mr-3 table-button edit" v-b-tooltip.hover title="Edit" 
						@click="editLtv(row.item)"
						>
						<i class="fa fa-pencil-square-o"></i>
						</b-button>
						<!-- <b-button
						size="sm"
						class="table-button delete" v-b-tooltip.hover title="Hapus"
						@click="deleteLtv(row.item.id)"
						>
						<i class="fa fa-trash"></i>
						</b-button> -->
					</template>
					</b-table>
				</div>
			</b-card>

			<b-card>
				<template v-slot:header>
                    <h5>Persentase Jasa Emas</h5>
                </template>
				<div class="persentase-jasa-emas form-content-wrapper">
					<b-table borderless hover
                        :busy="isBusy"
                        :items="input.jasaEmas.entries" 
                        :fields="fieldsJasa" 
                        responsive class="mb-3">
						<template v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>  Loading data...</strong>
                            </div>
                        </template>
						<template v-slot:top-row>
                            <td>
								<div class="jasa-emas-label">Dibawah</div>
							</td>
							<td>
								<b-input-group prepend="Rp.">
									<b-form-input v-model="input.jasaEmas.dibawah" name="jasaEmasDibawah" required></b-form-input>
								</b-input-group>
							</td>
                            <td>
								<b-input-group append="%">
									<b-form-input v-model="input.jasaEmas.dibawahJasa1" name="dibawahJasa1" step="0.01" type="number" @blur="roundPersen('dibawah', 'jasa1')" required></b-form-input>
								</b-input-group>
							</td>
							<td>
								<b-input-group append="%">
									<b-form-input v-model="input.jasaEmas.dibawahJasa2" name="dibawahJasa2" step="0.01" type="number" @blur="roundPersen('dibawah', 'jasa2')" required></b-form-input>
								</b-input-group>
							</td>
							<td>
								<div class="jasa-emas-action">
									<b-button size="sm" class="table-button view" v-b-tooltip.hover title="Tambah" name="addJasa" @click="addJasaEmas(-1)">
										<i class="fa fa-plus"></i>
									</b-button>
								</div>
							</td>
                        </template>
						<template v-slot:cell(dari)="row">
							<b-input-group prepend="Rp.">
								<b-form-input v-model="row.item.dari" name="jasaEmasDari" required></b-form-input>
							</b-input-group>
						</template>
						<template v-slot:cell(sampai)="row">
							<b-input-group prepend="Rp.">
								<b-form-input v-model="row.item.sampai" name="jasaEmasSampai" required></b-form-input>
							</b-input-group>
						</template>
						<template v-slot:cell(jasa1)="row">
							<b-input-group append="%">
								<b-form-input v-model="row.item.jasa1" name="jasaEmasJasa1" step="0.01" type="number" @blur="roundPersen(row.index, 'jasa1')" required></b-form-input>
							</b-input-group>
						</template>
						<template v-slot:cell(jasa2)="row">
							<b-input-group append="%">
								<b-form-input v-model="row.item.jasa2" name="jasaEmasJasa2" step="0.01" type="number" @blur="roundPersen(row.index, 'jasa2')" required></b-form-input>
							</b-input-group>
						</template>
						<template v-slot:cell(action)="row">
							<div class="no-wrap jasa-emas-action">
								<b-button size="sm" class="table-button view mr-3" v-b-tooltip.hover title="Tambah" name="addJasa" @click="addJasaEmas(row.index)">
									<i class="fa fa-plus"></i>
								</b-button>
								<b-button size="sm" class="table-button delete" v-b-tooltip.hover title="Hapus" name="removeJasa" @click="removeJasaEmas(row.index)">
									<i class="fa fa-trash"></i>
								</b-button>
							</div>
						</template>
						<template v-slot:custom-foot>
                            <td>
								<div class="jasa-emas-label">Diatas</div>
							</td>
							<td>
								<b-input-group prepend="Rp.">
									<b-form-input v-model="input.jasaEmas.diatas" name="jasaEmasDiatas" required></b-form-input>
								</b-input-group>
							</td>
                            <td>
								<b-input-group append="%">
									<b-form-input v-model="input.jasaEmas.diatasJasa1" name="diatasJasa1" step="0.01" type="number" @blur="roundPersen('diatas', 'jasa1')" required></b-form-input>
								</b-input-group>
							</td>
							<td>
								<b-input-group append="%">
									<b-form-input v-model="input.jasaEmas.diatasJasa2" name="diatasJasa2" step="0.01" type="number" @blur="roundPersen('diatas','Jasa2')" required></b-form-input>
								</b-input-group>
							</td>
							<td></td>
                        </template>
					</b-table>
					<div class="form-wrapper-btn submit-btn-wrapper">
						<b-button type="button" name="updateJasaEmas" @click="confirmEditJasaEmas()" variant="pgiBtn">Update</b-button>
					</div>
				</div>
			</b-card>
			
			<!-- <b-card v-for="merk of input.beratJenis">
				<template v-slot:header>
                    <h5>Berat Jenis {{ merk.merk.name }}</h5>
                </template>
				<div class="d-flex justify-content-end align-items-start pb-3">
					<b-button variant="pgiBtn" @click="addBeratJenis(merk.merk.id)">
						<i class="fa fa-plus mr-1"></i>
						Tambah Berat Jenis
					</b-button>
				</div>
				<div class="persentase-jasa-emas form-content-wrapper">
					<b-table borderless hover
                        :busy="isBusy"
                        :items="merk.detail" 
                        :fields="fieldsBJ" 
                        responsive class="mb-3">
						<template v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>  Loading data...</strong>
                            </div>
                        </template>
						<template v-slot:cell(dari)="row">
							<b-input-group append="Gr">
								<b-form-input v-model="row.item.dari" name="beratJenisDari" min="0" step="0.01" @blur="roundPersen(row.index, 'gram1' ,merk.merk.id)" type="number" required></b-form-input>
							</b-input-group>
						</template>
						<template v-slot:cell(sampai)="row">
							<b-input-group append="Gr">
								<b-form-input v-model="row.item.sampai" name="beratJenisSampai" min="0" step="0.01" @blur="roundPersen(row.index, 'gram2' ,merk.merk.id)" type="number" required></b-form-input>
							</b-input-group>
						</template>
						<template v-slot:cell(karat)="row">
							<b-input-group>
								<b-form-input v-model="row.item.karat" name="karat" min="0" step="1" type="number" required></b-form-input>
							</b-input-group>
						</template>
						<template v-slot:cell(diterima)="row">
							<div class="no-wrap">
								<b-form-select v-model="row.item.diterima" :options="optStatusBeratJenis" size="sm" class="rounded-lg" :class="{ 'bg-success': row.item.diterima, 'bg-danger': !row.item.diterima }"></b-form-select>
							</div>
						</template>
						<template v-slot:cell(action)="row">
							<div class="no-wrap jasa-emas-action">
								<b-button size="sm" class="table-button delete" v-b-tooltip.hover title="Hapus" name="removeBeratJenis" @click="removeBeratJenis(merk.merk.id , row.index)">
									<i class="fa fa-trash"></i>
								</b-button>
							</div>
						</template>
					</b-table>
					<div class="form-wrapper-btn submit-btn-wrapper">
						<b-button type="button" name="updateJasaEmas" @click="confirmEditBeratJenisEmas(merk.merk.id)" variant="pgiBtn">Update</b-button>
					</div>
				</div>
			</b-card> -->


			<b-card>
				<template v-slot:header>
					<h5>Spesifikasi</h5>
                </template>
				<div class="form-content-wrapper">
	
				<b-button variant="pgiBtn" class="mb-4" @click="addSpesifikasi()">
					{{ (isBusy) ? 'Loading...' : 'Tambah Spesifikasi' }}
				</b-button>

					<b-table bordered hover show-empty :busy="isBusy" :items="spesifikasi" :fields="fieldsSpek" :no-local-sorting="false"
						@sort-changed="sortingChanged" responsive class="mb-3">
						<template v-slot:table-busy>
							<div class="text-center text-danger my-2">
								<b-spinner class="align-middle"></b-spinner>
								<strong> Loading data...</strong>
							</div>
						</template>
						<template v-slot:empty>
							Tidak ada data.
						</template>
						
						<template v-slot:cell(reduction)="row">
							{{ row.item.reduction + " %" }}
						</template>
						<template v-slot:cell(isActive)="row">
							<b-badge variant="success" v-if="row.item.isActive == true">AKTIF</b-badge>
							<b-badge variant="danger" v-else>NON-AKTIF</b-badge>
						</template>
						<template v-slot:cell(action)="row">
							<b-button size="sm" class="mr-3 table-button edit" v-b-tooltip.hover title="Edit" @click="modalEdit(row.item)">
								<i class="fa fa-pencil-square-o"></i>
							</b-button>
						</template>
					</b-table>

					<div class="pagination-wrapper d-flex align-items-center justify-content-between">
						<b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
							<b-form-select v-model="paginate.show" id="showItems" :options="options" @change="onLimitChange">
								<template v-slot:first>
									<b-form-select-option :value="null" disabled />
								</template>
							</b-form-select>
							<span class="ml-2">{{ paginate.totalViewText }}</span>
						</b-input-group>
						<b-pagination class="mb-0" v-model="paginate.currentPage" :total-rows="paginate.rows" :per-page="paginate.perPage"
							aria-controls="my-table" @input="onPageChange"></b-pagination>
					</div>

				</div>
			</b-card>
		</div>
		<b-modal id="modal-history-harga" size="xl" title="History Harga Emas" no-close-on-esc no-close-on-backdrop>

			<div class="text-center" v-if="isLoadDataHistory">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div v-else>
				
				<div class="search-wrapper d-flex align-items-center justify-content-between">
					<b-form-group
						label="Filter"
						label-for="filterInput"
						class="form-inline form-group-wrapper mb-3"
					>   
						<div class="d-flex search-input-wrapper">
							<b-form-input class="ml-2"
								v-model="input.filterTanggalMulai" name="filterFromDate"
								id="filterDate"
								type="date"
							></b-form-input>
							<span class="ml-2 mr-2 d-flex align-items-center">s/d</span>
							<b-form-input class="mr-2"
								v-model="input.filterTanggalAkhir" name="filterToDate"
								type="date"
							></b-form-input>
							<b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter()"> 
								<i class="fa fa-search"></i>
							</b-button>
							<b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onResetHargaEmas()">Reset</b-button>
						</div>
					</b-form-group>
				</div>
				<b-table bordered hover show-empty
					:busy="isBusy"
					:items="historyHargaEmas" 
					:fields="fields"
					:no-local-sorting="false"
					@sort-changed="sortingChanged" 
					responsive class="mb-3">
					<template v-slot:table-busy>
						<div class="text-center text-danger my-2">
							<b-spinner class="align-middle"></b-spinner>
							<strong>  Loading data...</strong>
						</div>
					</template>
					<template v-slot:empty>
						Tidak ada data history emas.
					</template>
					<template v-slot:cell(tanggal)="row">
						<div>{{$helper.changeDateFormat(row.item.createdAt)}} - {{$helper.changeDateFormatGetHour(row.item.createdAt)}}</div>
						<div class="smallText text-muted">{{row.item.createdBy}}</div>
					</template>
					<template v-slot:cell(hargaSebelum)="row">
						<p class="mb-0" v-if="row.item.hargaSebelum !== null">Rp. {{$helper.addThousandSeparator(row.item.hargaSebelum)}} </p>
					</template>
					<template v-slot:cell(hargaSesudah)="row">
						<p class="mb-0" v-if="row.item.hargaSesudah !== null">Rp. {{$helper.addThousandSeparator(row.item.hargaSesudah)}} </p>
					</template>
					<template v-slot:cell(path)="row">
						<img class="img-fluid" :src="row.item.path" alt="img" v-if="row.item.path !== null">
					</template>
				</b-table>
				<div class="pagination-wrapper d-flex align-items-center justify-content-between">
					<b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
						<b-form-select v-model="paginateHargaEmas.show" id="showItems" :options="options" @change="onLimitChangeHargaEmas">
							<template v-slot:first>
								<b-form-select-option :value="null" disabled />
							</template>
						</b-form-select>
						<span class="ml-2">{{ paginateHargaEmas.totalViewText }}</span>
					</b-input-group>
					<b-pagination class="mb-0"
					v-model="paginateHargaEmas.currentPage"
					:total-rows="paginateHargaEmas.rows"
					:per-page="paginateHargaEmas.perPage"
					aria-controls="my-table"
					@input="onPageChangeHargaEmas"
					></b-pagination>
				</div>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeHistoryHargaBtn" @click="cancel()">
                    Cancel
                </b-button>
            </template>
        </b-modal>
		<b-modal id="modal-edit-harga" title="Edit Harga Emas" no-close-on-esc no-close-on-backdrop>
            <b-form id="updateHargaForm" @submit.prevent="confirmEditHargaEmas()">
                <div class="form-content-wrapper mb-0">
                    <h6 class="form-title">HARGA</h6>
                    <b-form-group >
                        <b-input-group prepend="Rp.">
                            <b-form-input v-model="input.hargaEmasBaru" name="hargaEmasBaru"></b-form-input>
                        </b-input-group>
                    </b-form-group>
					    <FotoPendukung 
						:fotoPendukung="foto"
						:length="1"
						:minLength="1"
						:lat="lat"
						:long="long"
						@showModalCam="handleShowModalCam"
						@showModalPreview="handleShowModalPreview"
						/>
					<!-- <div class="browse-foto">
                        <b-form-file v-model="photo" name="fotoBarangPendukung" :state="Boolean(photo)"
                            drop-placeholder="Drop file here..." accept=".jpg, .png, .jpeg"
                            @input="browseFile(photo.type, photo.file, (photo.path != null) && true, photo.id)">
                        </b-form-file>
                        <b-button variant="cancelBtn">
                        	<i class="fa fa-upload"></i>
                            Upload
                        </b-button>
                    </div> -->
                </div>
            </b-form>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeEditHargaBtn" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="updateHargaBtn" type="submit" form="updateHargaForm">
                    Ubah
                </b-button>
            </template>
        </b-modal>
		<ModalConfirm id="modal-confirm-editHarga" title="Konfirmasi Edit Harga Emas" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengubah harga emas ini?" @submit="submitEditHargaEmas" />
		<ModalConfirm id="modal-confirm-submit-spesifikasi" title="Konfirmasi Edit Spesifikasi Emas" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengubah spesifikasi emas ini?" @submit="onSubmitSpesifikasi" />
     	<ModalConfirm id="modal-confirm-editJasa" title="Konfirmasi Edit Jasa Emas" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengubah jasa emas ini?" @submit="submitJasaHargaEmas" />
     	<ModalConfirm id="modal-confirm-editBerat" title="Konfirmasi Edit Berat Jenis Emas" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengubah berat jenis emas ini?" @submit="submitKaratEmas" />
		<!-- <ModalConfirm id="modal-confirm-hapus-spesifikasi" title="Confirm Hapus Spesifikasi"  desc="Apakah anda yakin untuk menghapus spesifikasi barang ini?" @submit="onSubmitHapusSpesifikasi" />
		<ModalConfirm id="modal-confirm-non-aktif-spesifikasi" title="Confirm Non Aktif Spesifikasi"  desc="Apakah anda yakin untuk menonaktifkan spesifikasi barang ini?" @submit="onSubmitNonAktifSpesifikasi" />
        <ModalConfirm id="modal-confirm-aktif-spesifikasi" title="Confirm Aktif Spesifikasi"  desc="Apakah anda yakin untuk mengaktifkan spesifikasi ini?" @submit="onSubmitAktifSpesifikasi" /> -->
        <ModalConfirm id="modal-confirm-add-spek" title="Confirm Tambah Spesifikasi"  desc="Apakah anda yakin untuk menambah spesifikasi ini?" @submit="onSubmitSpesifikasi" />

		<b-modal id="modal-add-spek" centered title="Tambah Spek" hide-footer no-close-on-backdrop>
			
			<div>
				<b-form-group>
                    <label>Name</label>
                    <b-form-input v-model="input.spesifikasi.name" name="spesifikasiName" placeholder="Name" class="mr-2" required></b-form-input>
                </b-form-group>
				
                <b-form-group>
                    <label>Nama pada Cetakan</label>
                    <b-form-input v-model="input.spesifikasi.shortName" name="spesifikasiShortName" placeholder="Short Name" class="mr-2" required></b-form-input>
                </b-form-group>
				
				<label>Persen</label>
				<b-input-group append="%">
					<b-form-input v-model="input.spesifikasi.reduction" name="spesifikasireduction" step="0.01" type="number" @blur="roundPersenSpek(1)" required></b-form-input>
				</b-input-group>

				<b-row no-gutters class="pt-2">
                    <b-col cols="7" sm="3" xl="2">
                        Aktif
                    </b-col>
                    <b-col cols="1">
						<b-form-checkbox v-model="input.spesifikasi.isActive" name="spesifikasiAktif" value="true" unchecked-value="false">
						</b-form-checkbox>
                    </b-col>
                </b-row>
                <div class="smallText text-muted">
                    Checklist untuk mengaktifkan
                </div>			
			</div>

			<div class="d-flex justify-content-end mt-4">
				<b-button variant="pgiBtn" name="closeDetailBtn" :disabled="isBusy" @click="confirmAddSpek()">
					{{ (isBusy) ? 'Loading...' : 'Submit' }}
				</b-button>
			</div>
        </b-modal>

		<b-modal id="modal-edit-spek" centered title="Edit Spek" hide-footer no-close-on-backdrop>
			
			<div v-if="activeId != null">
				<b-form-group>
                    <label>Name</label>
                    <b-form-input v-model="activeId.name" name="spesifikasiName" placeholder="Name" class="mr-2" required></b-form-input>
                </b-form-group>
				
                <b-form-group>
                    <label>Nama pada Cetakan</label>
                    <b-form-input v-model="activeId.shortName" name="spesifikasiShortName" placeholder="Short Name" class="mr-2" required></b-form-input>
                </b-form-group>
				
				<label>Persen</label>
				<b-input-group append="%">
					<b-form-input v-model="activeId.reduction" name="spesifikasireduction" step="0.01" type="number" @blur="roundPersenSpek(2)" required></b-form-input>
				</b-input-group>

				<b-row no-gutters class="pt-2">
                    <b-col cols="7" sm="3" xl="2">
                        Aktif
                    </b-col>
                    <b-col cols="1">
						<b-form-checkbox v-model="activeId.isActive" name="spesifikasiAktif" value="true" unchecked-value="false">
						</b-form-checkbox>
                    </b-col>
                </b-row>
                <div class="smallText text-muted">
                    Checklist untuk mengaktifkan
                </div>
			</div>

			<div class="d-flex justify-content-end mt-4">
				<b-button variant="pgiBtn" name="closeDetailBtn" :disabled="isBusy" @click="submitEditSpesifikasi()">
					{{ (isBusy) ? 'Loading...' : 'Submit' }}
				</b-button>
			</div>
        </b-modal>

		<ModalWebCam @photoTaken="setResult"  />
        <ModalPreview :fotoPreview="activeFotoPreview" />
	</div>
</template>

<script>
import SpesifikasiEmas from '../../../components/spesifikasi/SpesifikasiEmas'
import SpesifikasiNonAktifEmas from '../../../components/spesifikasi/SpesifikasiNonAktifEmas';
import FotoPendukung from '../../../components/webcam/FotoPendukung';
import ModalPreview from '../../../components/webcam/ModalPreview.vue';
import ModalWebCam from '../../../components/webcam/ModalWebCam.vue';
import StateInputHandler from '@/components/common/StateInputHandler'
import EmptyStateInput from '@/components/common/EmptyStateInput'

export default {
	name: 'master-harga-emas',
	components: { 
		SpesifikasiEmas,
		SpesifikasiNonAktifEmas,
		FotoPendukung,
		ModalPreview,
		ModalWebCam,
		StateInputHandler,
		EmptyStateInput
    },
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
			activeId: null,
		
            input: {
                show: 10,
                filterTanggalMulai: null,
                filterTanggalAkhir: null,
				hargaEmasBaru: null,
				jasaEmas: {
					dibawah: 0,
					diatas: 0,
					dibawahJasa1: null,
					dibawahJasa2: null,
					diatasJasa1: null,
					diatasJasa2: null,
					entries: [
						{
							dari: 0,
							sampai: 0,
							jasa1: null,
							jasa2: null
						}
					]
				},
				beratJenis : [],
				beratJenisMerah : [],
				spesifikasi : {
					name: '',
					shortName: '',
					reduction: null,
					isActive: false
				},
			},
			spesifikasi :[],
			jasaEmas: {},
            indexJasaEmas: 0,
			ltvList: [],
			newLtv: {
				id: null,
				jenisId: null,
				persen: null,
				merk: null,
				nama: null,
				isEdit: false,
			},
			fieldsLtv: [
				{ key: 'jenis', label: 'Jenis' },
				{ key: 'merk', label: 'Merk' },
				{ key: 'nominalPersen', label: 'Persen (%)' },
				{ key: 'aksi', label: 'Aksi' },
			],

            fields: [
				{ key: "tanggal", label: "Tanggal"},
                { key: "hargaSebelum", label: "Harga Sebelum"},
                { key: "hargaSesudah", label: "Harga Setelah"},
				{ key: "path", label: "Foto"}
			],
			fieldsJasa: [
				{ key: "dari", label: "Dari"},
                { key: "sampai", label: "Sampai"},
				{ key: "jasa1", label: "0 - 15 hari"},
				{ key: "jasa2", label: "16 - Jatuh Tempo"},
                { key: "action", label: "Aksi"}
			],
			fieldsBJ: [
				{ key: "dari", label: "Dari"},
                { key: "sampai", label: "Sampai"},
				{ key: "karat", label: "Karat"},
				{ key: "diterima", label: "Diterima"},
				{ key: "action", label: "Aksi"}
			],
			fieldsSpek: [
                { key: "name", label: "Nama" },
                { key: "shortName", label: "Nama pada Cetakan" },
                { key: "reduction", label: "Persen" },
                { key: "isActive", label: "Status" },
                { key: "action", label: "Aksi" }
            ],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
			],
			optStatusBeratJenis:[
				{text:'Diterima', value:true},
				{text:'Tidak Diterima', value:false},
			],
			nonAktifSpesifikasiEmas: [],
			hargaEmasSekarang: 0,
			historyHargaEmas: [],

			paginateHargaEmas: {
				show: 10,
				currentPage: 1,
				perPage: 10,
				rows: null,
				totalViewText: "",
				page: '',
				size: '',
				query: "",
			},

			paginate: {
				show: 10,
				currentPage: 1,
				perPage: 10,
				rows: null,
				totalViewText: "",
				page: '',
				size: '',
				query: "",
			},
			
			loading: false,
			isLoadDataHistory: false,
			jenisList :[],
			optJenisEmas: [],
			lat: -6.2,
			long: 106.8,
			presignedUrl: null,
			foto: {
				index: 0,
				fotoBarangPendukung: null,
				fotoBarangPendukungBase64: null,
				activeFotoPendukungBase64: null,
				urlFotoBarangPendukung: null,
				checkFotoBarangPendukung: false,
				fotoBarangPendukungPlaceholder: 'Pilih Foto',
			},
				indexFotoPendukung: 1,
				fotoPendukungError: false,
				activeFotoPendukungIndex: null,
				activeFotoPreviewIndex: null,
				minLengthFotoPendukung: 0,
				activeFotoPreview: "",
				stateMerkBarang: {
					isLoading: false,
					error: null,
					data: []
				},
				isLoadingSubmit: false,
				isLoadingLtv: false,
				dataPercentageValue: 0,
			}
    }, 

    watch:{
        "input.hargaEmasBaru": function(newValue) {
            if(this.input.hargaEmasBaru != 0){
                let cleanValue = this.$helper.changeToValue(newValue)
                const result = cleanValue.replace(/(?!^-)[^0-9]/g, "")
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                this.$nextTick(() => this.input.hargaEmasBaru = result)
            }
		},
		'input.jasaEmas': {
			deep: true,
			handler(newValue){
				if(this.initStatus == 1){
					if(newValue.dibawah != 0){
						let cleanValue = this.$helper.changeToValue(newValue.dibawah)
						const result = cleanValue.replace(/(?!^-)[^0-9]/g, "")
							.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
						this.$nextTick(() => this.input.jasaEmas.dibawah = result)
					}
					if(newValue.diatas != 0){
						let cleanValue = this.$helper.changeToValue(newValue.diatas)
						const result = cleanValue.replace(/(?!^-)[^0-9]/g, "")
							.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
						this.$nextTick(() => this.input.jasaEmas.diatas = result)
					}
					for(var i=0; i<newValue.entries.length; i++){
						if(newValue.entries[i].dari != 0){
							let cleanValue = this.$helper.changeToValue(newValue.entries[i].dari)
							const result = cleanValue.replace(/(?!^-)[^0-9]/g, "")
								.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
							this.input.jasaEmas.entries[i].dari = result
						}
						if(newValue.entries[i].sampai != 0){
							let cleanValue = this.$helper.changeToValue(newValue.entries[i].sampai)
							const result = cleanValue.replace(/(?!^-)[^0-9]/g, "")
								.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
							this.input.jasaEmas.entries[i].sampai = result
						}
					}
				}
			}
		},
		'newLtv.jenisId': {
			handler(newValue) {
				if (newValue) {
					this.newLtv.merk = null
					this.fetchMerkBarangByJenis()
				}
			}
		},
		'newLtv.persen'(newValue) {
			if (!newValue) return;
    	const clean = newValue.toString().replace(/\D/g, '');
    
    	const final = parseInt(clean) > 100 ? '100' : clean;

			if (newValue !== final) {
				this.$nextTick(() => {
					this.newLtv.persen = final;
				});
			}
  	}

	},
    methods: {
		//----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
			this.paginate.page = 0
            this.paginate.size = this.paginate.show
		
            this.paginate.query = this.$helper.makeQuery(this.paginate.page, this.paginate.size)

			let getJasaEmas = this.$axios.get("jasa-emas/").then(response => {
				this.jasaEmas = response.data
				this.input.jasaEmas.dibawah = this.$helper.addThousandSeparator(response.data.dibawah)
				this.input.jasaEmas.diatas = this.$helper.addThousandSeparator(response.data.diatas)
				this.input.jasaEmas.dibawahJasa1 = response.data.dibawahJasa1
				this.input.jasaEmas.dibawahJasa2 = response.data.dibawahJasa2
				this.input.jasaEmas.diatasJasa1 = response.data.diatasJasa1
				this.input.jasaEmas.diatasJasa2 = response.data.diatasJasa2
				this.input.jasaEmas.entries = []
				for (var x of response.data.entries) {
                    let nominalDari, nominalSampai = null
					nominalDari = this.$helper.addThousandSeparator(x.dari);
					nominalSampai = this.$helper.addThousandSeparator(x.sampai);

					this.input.jasaEmas.entries.push({
						dari: nominalDari,
						sampai: nominalSampai,
						jasa1: x.jasa1,
						jasa2: x.jasa2
					})
                }
            })
			
			let getHargaEmasSekarang = this.$axios.get("harga-emas/current").then(response =>{
				this.hargaEmasSekarang = response.data.id
			})

			let beratJenis = this.$axios.get("karat-emas/").then(response =>{
				
				this.input.beratJenis = response.data
				
				for(let merk of this.input.beratJenis){
					for(let detail of merk.detail){
						detail.dari = parseFloat(detail.dari).toFixed(2)
				 		detail.sampai = parseFloat(detail.sampai).toFixed(2)
					}
				}
			})

			let spesifikasiEmas = this.$axios.get("spesifikasi-emas/?page=0&size=10").then(response =>{
				this.spesifikasi = response.data.data
				this.updateTotalItem(response.data.total)
			})
            Promise.all([getHargaEmasSekarang, getJasaEmas, beratJenis,spesifikasiEmas, this.getPercentageValue()]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                this.initStatus = -1
            })

		},

		getSpek() {
            this.toggleBusy()
            this.spesifikasi = []

            this.$axios.get("spesifikasi-emas/" + this.paginate.query).then(response => {
                this.spesifikasi = response.data.data
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
                this.loading = false
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.toggleBusy()
                    this.loading = false
                })
        },
		
		getBeratJenis(){
			this.toggleBusy()
			this.$axios.get("karat-emas/").then(response =>{
					
				this.input.beratJenis = response.data
				
				for(let merk of this.input.beratJenis){
					for(let detail of merk.detail){
						detail.dari = parseFloat(detail.dari).toFixed(2)
				 		detail.sampai = parseFloat(detail.sampai).toFixed(2)
					}
				}

			}).finally(() => {
				this.toggleBusy()
            })
		},

		getHistoryHargaEmas(){
            this.toggleBusy()
            this.historyHargaEmas = []
            
            if(this.$helper.isNotNullAndNotEmpty(this.input.filterTanggalMulai)) this.paginateHargaEmas.query = this.paginateHargaEmas.query + "&filterStart=" + this.input.filterTanggalMulai
            if(this.$helper.isNotNullAndNotEmpty(this.input.filterTanggalAkhir)) this.paginateHargaEmas.query = this.paginateHargaEmas.query + "&filterEnd=" + this.input.filterTanggalAkhir
            
            this.$axios.get("harga-emas/"+this.paginateHargaEmas.query).then(response => {
                this.historyHargaEmas = response.data.data
                this.toggleBusy()
                this.updateTotalItemHargaEmas(response.data.total)
                this.loading = false
            })
            .catch(error => {
                this.$helper.parseError(this, error)
                this.toggleBusy()
                this.loading = false
            })
        },

		//----------------- Fungsi Pagination, Sorting, dan loading -----------------

        onLimitChange(){
            this.paginate.size = this.paginate.show
            this.paginate.perPage = this.paginate.show
            this.paginate.currentPage = 1
            this.paginate.page = 0
            this.paginate.query = this.$helper.makeQuery(0, this.paginate.size)
            this.getSpek()
        },

        onPageChange(){
            if (this.loading == false){
                this.paginate.page = this.paginate.currentPage - 1
                this.paginate.query = this.$helper.makeQuery(this.paginate.page, this.paginate.size)
                this.getSpek()
            }
        },

        onLimitChangeHargaEmas(){
            this.paginateHargaEmas.size = this.paginateHargaEmas.show
            this.paginateHargaEmas.perPage = this.paginateHargaEmas.show
            this.paginateHargaEmas.currentPage = 1
            this.paginateHargaEmas.page = 0
            this.paginateHargaEmas.query = this.$helper.makeQuery(0, this.paginateHargaEmas.size)
            this.getHistoryHargaEmas()
        },

        onPageChangeHargaEmas(){
            if (this.loading == false){
                this.paginateHargaEmas.page = this.paginateHargaEmas.currentPage - 1
                this.paginateHargaEmas.query = this.$helper.makeQuery(this.paginateHargaEmas.page, this.paginateHargaEmas.size)
		
                this.getHistoryHargaEmas()
            }
        },

        sortingChanged(ctx) {
            if(ctx.sortBy != ""){
                this.input.sortBy = ctx.sortBy
                this.input.sortDesc = ctx.sortDesc
                this.onFilter()
            }
        },

        onResetHargaEmas(){
            this.input.filterTanggalMulai = null
            this.input.filterTanggalAkhir = null
            this.paginateHargaEmas.currentPage = 1
            this.paginateHargaEmas.page = 0
            this.paginateHargaEmas.query = this.$helper.makeQuery(0, this.paginateHargaEmas.size)
            this.loading = true
            this.getHistoryHargaEmas()
        },

        onFilter(){
            this.paginateHargaEmas.page = 0
            this.paginateHargaEmas.currentPage = 1
            this.paginateHargaEmas.query = this.$helper.makeQuery(0, this.paginateHargaEmas.size)
            this.loading = true

			if(!this.$helper.isNotNullAndNotEmpty(this.input.filterTanggalAkhir) && !this.$helper.isNotNullAndNotEmpty(this.input.filterTanggalMulai)){
				this.$helper.toastErr(this, "Mohon isi tanggal mulai dan tanggal akhir filter!")
			}else if(this.$helper.isNotNullAndNotEmpty(this.input.filterTanggalAkhir) && !this.$helper.isNotNullAndNotEmpty(this.input.filterTanggalMulai)){
                this.$helper.toastErr(this, "Mohon isi tanggal mulai dan tanggal akhir filter!")
            }else if(!this.$helper.isNotNullAndNotEmpty(this.input.filterTanggalAkhir) && this.$helper.isNotNullAndNotEmpty(this.input.filterTanggalMulai)){
                this.$helper.toastErr(this, "Mohon isi tanggal mulai dan tanggal akhir filter!")
            }else if((this.$helper.isNotNullAndNotEmpty(this.input.filterTanggalAkhir) && this.$helper.isNotNullAndNotEmpty(this.input.filterTanggalMulai)) && (Date.parse(this.input.filterTanggalAkhir) < Date.parse(this.input.filterTanggalMulai))){
                this.$helper.toastErr(this, "Tanggal akhir lebih kecil daripada tanggal mulai!")
            }else{
                this.getHistoryHargaEmas()
            }
        },
        

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItemHargaEmas(total){
            let limit = null
            let prevLimit = null
            this.paginateHargaEmas.perPage = this.paginateHargaEmas.size
            this.paginateHargaEmas.rows = total
            prevLimit = this.paginateHargaEmas.page * this.paginateHargaEmas.size + 1
            limit = this.paginateHargaEmas.page * this.paginateHargaEmas.size + this.paginateHargaEmas.size
            if (limit > this.paginateHargaEmas.rows) limit = this.paginateHargaEmas.rows
            this.paginateHargaEmas.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.paginateHargaEmas.rows + " entri"
		},

        updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.paginate.perPage = this.paginate.size
            this.paginate.rows = total
            prevLimit = this.paginate.page * this.paginate.size + 1
            limit = this.paginate.page * this.paginate.size + this.paginate.size
            if (limit > this.paginate.rows) limit = this.paginate.rows
            this.paginate.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.paginate.rows + " entri"
		},

		openHistoryHargaEmas(){
			this.isLoadDataHistory = true
			this.$bvModal.show("modal-history-harga")
            this.paginateHargaEmas.page = 0
            this.paginateHargaEmas.size = this.paginateHargaEmas.show
            this.paginateHargaEmas.query = this.$helper.makeQuery(this.paginateHargaEmas.page, this.paginateHargaEmas.size)
	
			this.$axios.get("harga-emas/"+this.paginateHargaEmas.query).then(response => {
                this.historyHargaEmas = response.data.data
				this.updateTotalItemHargaEmas(response.data.total)
			})
			.catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
				this.isLoadDataHistory = false
            })

		},
		
		openEditHargaEmas(){
			this.$bvModal.show("modal-edit-harga")
		},

		confirmEditHargaEmas(){
			if (this.input.hargaEmasBaru === "") {
                this.$helper.toastErr(this, "Harga emas tidak bisa kosong")
            } else this.$bvModal.show("modal-confirm-editHarga")
		},
		
		async submitEditHargaEmas() {
		let nominal = this.$helper.removeThousandSeparator(this.input.hargaEmasBaru);

		try {
			this.isSubmitting = true;

			const uploadResponse = await fetch(this.presignedUrl, {
			method: "PUT",
			headers: {
				"Content-Type": "image",
			},
			body: this.foto.fotoBarangPendukung,
			});

			if (!uploadResponse.ok) {
			throw new Error("Upload gambar gagal");
			}

			const uploadedFilePath = this.presignedUrl.split("?")[0];

			const endpoint = `harga-emas/?file=${uploadedFilePath}&harga=${nominal}`;
			await this.$axios.post(endpoint);

			this.hargaEmasSekarang = nominal;
			this.$bvModal.hide("modal-edit-harga");
			this.$bvModal.hide("modal-confirm-editHarga");
			this.$helper.toastSucc(this, "Harga Emas berhasil diubah!");
		} catch (error) {
			this.$helper.parseError(this, error);
		} finally {
			this.isSubmitting = false;
			this.paginateHargaEmas.page = 0;
			this.paginateHargaEmas.currentPage = 1;
			this.paginateHargaEmas.query = this.$helper.makeQuery(0, this.size);
			this.loading = true;
		}
		},


		addJasaEmas(index){
			this.input.jasaEmas.entries.splice(index+1, 0, {
				dari: 0, 
				sampai: 0, 
				jasa1: 0, 
				jasa2: 0
			})
		},
		removeJasaEmas(index) {
			this.input.jasaEmas.entries.splice(index, 1)
		},

		addBeratJenis(index){
			let idx = this.input.beratJenis.findIndex(item => item.merk.id == index)
			this.input.beratJenis[idx].detail.push({
				id:0,
				dari: 0, 
				sampai: 0, 
				diterima:true,
				karat: 0, 
			})
		},
		removeBeratJenis(index , row) {
			let idx = this.input.beratJenis.findIndex(item => item.merk.id == index)
			this.input.beratJenis[idx].detail.splice(row, 1)
		},
		roundPersen(row, variable ,index){
			if(row == 'dibawah'){
				if(variable == 'jasa1'){
					var x = Number(this.input.jasaEmas.dibawahJasa1).toFixed(2);
					this.input.jasaEmas.dibawahJasa1 = x;
				}else if(variable == 'jasa2'){
					var x = Number(this.input.jasaEmas.dibawahJasa2).toFixed(2);
					this.input.jasaEmas.dibawahJasa2 = x;
				}
			}else if(row == 'diatas'){
				if(variable == 'jasa1'){
					var x = Number(this.input.jasaEmas.diatasJasa1).toFixed(2);
					this.input.jasaEmas.diatasJasa1 = x;
				}else if(variable == 'jasa2'){
					var x = Number(this.input.jasaEmas.diatasJasa2).toFixed(2);
					this.input.jasaEmas.diatasJasa2 = x;
				}
			}

			if(variable == 'jasa1'){
				var x = Number(this.input.jasaEmas.entries[row].jasa1).toFixed(2);
				this.input.jasaEmas.entries[row].jasa1 = x;
			}
			else if (variable == 'jasa2'){
				var x = Number(this.input.jasaEmas.entries[row].jasa2).toFixed(2);
				this.input.jasaEmas.entries[row].jasa2 = x;
			}
			else if(variable == 'gram1'){
				let idx = this.input.beratJenis.findIndex(item => item.merk.id == index)
				var x = Number(this.input.beratJenis[idx].detail[row].dari).toFixed(2);
				this.input.beratJenis[idx].detail[row].dari = x;
			}
			else if(variable == 'gram2'){
				let idx = this.input.beratJenis.findIndex(item => item.merk.id == index)
				var x = Number(this.input.beratJenis[idx].detail[row].sampai).toFixed(2);
				this.input.beratJenis[idx].detail[row].sampai = x;
			}
			
		},

		confirmEditJasaEmas(){
			this.$bvModal.show("modal-confirm-editJasa")
		},

		confirmEditBeratJenisEmas(id){
			this.activeId = id
			this.$bvModal.show("modal-confirm-editBerat")
		},

		submitJasaHargaEmas(){
			let dataJasa = {}
			let nominalBawah = this.$helper.removeThousandSeparator(this.input.jasaEmas.dibawah)
            let nominalAtas = this.$helper.removeThousandSeparator(this.input.jasaEmas.diatas)
			let dataEntriesJasa = []
			for(let entriesJasa of this.input.jasaEmas.entries){
				let nominalDari = this.$helper.removeThousandSeparator(entriesJasa.dari)
				let nominalSampai = this.$helper.removeThousandSeparator(entriesJasa.sampai)
				dataEntriesJasa.push({
					dari: nominalDari,
					sampai: nominalSampai,
					jasa1: entriesJasa.jasa1,
					jasa2: entriesJasa.jasa2
				})
			}

			dataJasa.dibawah = nominalBawah
			dataJasa.diatas = nominalAtas
			dataJasa.dibawahJasa1 = this.input.jasaEmas.dibawahJasa1
			dataJasa.dibawahJasa2 = this.input.jasaEmas.dibawahJasa2
			dataJasa.diatasJasa1 = this.input.jasaEmas.diatasJasa1
			dataJasa.diatasJasa2 = this.input.jasaEmas.diatasJasa2
			dataJasa.entries = dataEntriesJasa


			this.$axios.post("jasa-emas/", dataJasa).then(response => {
                this.$bvModal.hide("modal-confirm-editJasa")
                this.$helper.toastSucc(this, "Jasa Emas berhasil diubah!")

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
				this.isSubmitting = false
            })

		},

		confirmEditKaratEmas(){
			this.$bvModal.show("modal-confirm-editJasa")
		},

		submitKaratEmas(){
			let idx = this.input.beratJenis.findIndex(item => item.merk.id == this.activeId)
			let datas = this.input.beratJenis[idx]

			for(var data of datas.detail){
				data.dari = parseFloat(data.dari).toFixed(2);
				data.sampai = parseFloat(data.sampai).toFixed(2);
			}

			this.$axios.post("karat-emas/", datas).then(response => {
                this.$bvModal.hide("modal-confirm-editBerat")
                this.$helper.toastSucc(this, "Berat Jenis Emas berhasil diubah!")
				this.getBeratJenis()
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
				this.isSubmitting = false
            })
		},

		addSpesifikasi() {
           this.input.spesifikasi ={
			name: '',
			shortName: '',
			reduction: 0 ,
			isActive: false
		   }
		   this.$bvModal.show("modal-add-spek")
        },

		confirmAddSpek(){
			if (this.$helper.isNullOrEmpty(this.input.spesifikasi.name)) {
				return	this.$helper.toastErr(this, "Mohon lengkapi data Spesifikasi!")
			}
			if (this.$helper.isNullOrEmpty(this.input.spesifikasi.shortName)) {
				return	this.$helper.toastErr(this, "Mohon lengkapi data Spesifikasi!")
			}
			if (this.$helper.isNullOrEmpty(this.input.spesifikasi.reduction)) {
				return	this.$helper.toastErr(this, "Mohon lengkapi data Spesifikasi!")
			}

			this.$bvModal.show("modal-confirm-add-spek")
		},
		submitEditSpesifikasi(){
		
			if (this.$helper.isNullOrEmpty(this.activeId.name)) {
				return	this.$helper.toastErr(this, "Mohon lengkapi data Spesifikasi!")
			}
			if (this.$helper.isNullOrEmpty(this.activeId.shortName)) {
				return	this.$helper.toastErr(this, "Mohon lengkapi data Spesifikasi!")
			}
			if (this.$helper.isNullOrEmpty(this.activeId.reduction)) {
				return	this.$helper.toastErr(this, "Mohon lengkapi data Spesifikasi!")
			}

			this.isBusy = true
			let payload = `?id=${this.activeId.id}&name=${encodeURIComponent(this.activeId.name)}&shortName=${encodeURIComponent(this.activeId.shortName)}&reduction=${this.activeId.reduction}&isActive=${this.activeId.isActive}`
            
            this.$axios.post(`/spesifikasi-emas/`+payload).then(response => {
				this.isBusy = false
				this.getSpek()
            })
            .catch(error => {
				this.$helper.parseError(this, error)
				this.isBusy = false
            })

			this.$bvModal.hide("modal-edit-spek")
		},
		onSubmitSpesifikasi(){
		
			this.isBusy = true
			let payload = '?name='+encodeURIComponent(this.input.spesifikasi.name)+`&shortName=${encodeURIComponent(this.input.spesifikasi.shortName)}&reduction=${this.input.spesifikasi.reduction}&isActive=${this.input.spesifikasi.isActive}`
            
            this.$axios.post(`/spesifikasi-emas/`+payload).then(response => {
				this.isBusy = false				
				this.getSpek()
            })
            .catch(error => {
				this.$helper.parseError(this, error)
				this.isBusy = false
            })
	
            this.$bvModal.hide("modal-confirm-add-spek")
            this.$bvModal.hide("modal-add-spek")
		},
		roundPersenSpek(form) {
			if (form == 1) {	
				if (this.input.spesifikasi.reduction > 100) {
					this.input.spesifikasi.reduction = 0
					this.$helper.toastErr(this,"nominal persen tidak boleh diatas 100")
				}else
				{	
					var x = Number(this.input.spesifikasi.reduction).toFixed(2);
					this.input.spesifikasi.reduction = x;
				}
			}
			if (form == 2) {	
				if (this.activeId.reduction > 100) {
					this.activeId.reduction = 0
					this.$helper.toastErr(this,"nominal persen tidak boleh diatas 100")
				}else
				{	
					var x = Number(this.activeId.reduction).toFixed(2);
					this.activeId.reduction = x;
				}
			}
        },
		modalEdit(item) {
            this.activeId = item
            this.$bvModal.show('modal-edit-spek')
        },

		async fetchJenisEmas() {
			try {
				const res = await this.$axios.get('/barang-jenis/emas')
				this.optJenisEmas = res.data
			} catch (err) {
				this.$helper.parseError(this, err)
			}
		},

		async fetchLtvList() {
			this.isLoadingLtv = true;
			try {
				const res = await this.$axios.get('/ltv-emas')
				this.ltvList = res.data
			} catch (err) {
				this.$helper.parseError(this, err)
			} finally {
				this.isLoadingLtv = false;
			}
		},

		editLtv(item) {
			this.newLtv = {
				id: item.id,
				merk: null,
				jenisId: null,
				nama: [item.jenis, item.merk].filter(Boolean).join(' - '),
				persen: item.nominalPersen,
				isEdit : true
			}
			this.$bvModal.show('modal-add-ltv')
		},
		showAddLtv(){
			this.newLtv = {
				id: null,
				jenisId: null,
				persen: null,
				merk: null,
				nama: null,
				isEdit:false
			}
			this.$bvModal.show('modal-add-ltv')
		},
		async addLtv() {
			let params = {
				nominalPersen: this.newLtv.persen,
			}
			this.isLoadingSubmit = true
			try {
				if(this.newLtv.isEdit){
					await this.$axios.put(`/ltv-emas/${this.newLtv.id}`,null, { params })
					this.$helper.toastSucc(this, 'LTV Emas berhasil di edit')
				} else {
					if (this.validateAddLtv()) {
						this.isLoadingSubmit = false
						return;
					}

					if (this.newLtv.jenisId) {
						params.jenisId = this.newLtv.jenisId
					}

					if (this.newLtv.merk) {
						params.merkId = this.newLtv.merk.id
					}

					await this.$axios.post('/ltv-emas', null, { params })
					this.$helper.toastSucc(this, 'LTV Emas berhasil ditambahkan')
				}

				this.$bvModal.hide('modal-add-ltv')
				this.newLtv = {
					id: null,
					jenisId: null,
					persen: null,
					merk: null,
					nama: null,
					isEdit:false
				}
				this.fetchLtvList()
			} catch (err) {
				this.$helper.parseError(this, err)
			} finally {
				this.isLoadingSubmit = false
			}
		},
		getPresignedUrl() {
		this.$axios
			.get(`harga-emas/create-url?contentType=image`)
			.then((response) => {
			this.presignedUrl = response.data.name;

			// this.uploadViaPresignedUrl(this.input)
			})
			.catch((error) => {
			this.$helper.parseError(this, error);
			});
		},
		handleShowModalCam() {
			this.$bvModal.show("modal-ambil-foto")
		},
		async setResult(result) {
			//letakin ke null masing2
            let formattedDate = this.$helper.formatTanggalDMY()
            let waktu = this.$helper.waktu24()
            //resize image
			var newResult = await this.$helper.resizeImage(result)

			//add timestamp & location
			let img = new Image()
			img.src = newResult
			img.onload = () => {
				let canvas = document.createElement('canvas')
				let ctx = canvas.getContext('2d')
				canvas.setAttribute("width", img.width);
				canvas.setAttribute("height", img.height);
				ctx.drawImage(img, 0, 0,)
				ctx.font = "14pt Arial";
				ctx.fillStyle = "#ffffff"; //<======= here
				ctx.fillText(formattedDate + ' ' + waktu, 10, img.height - 40 ,);
				ctx.strokeText(formattedDate + ' ' + waktu, 10, img.height - 40 ,);
				ctx.fillText(this.lat + ' ' +this.long, 10, img.height - 10 ,);
				ctx.strokeText(this.lat + ' ' +this.long, 10, img.height - 10 ,);
				let newBase64Str = canvas.toDataURL('image/jpeg', 0.9)

				this.foto.fotoBarangPendukungBase64 = newBase64Str
				this.foto.activeFotoPendukungBase64 = newBase64Str
				this.foto.fotoBarangPendukungPlaceholder = "Foto dari Kamera"
				this.foto.checkFotoBarangPendukung = true
			}
		},
		handleShowModalPreview(){
			this.activeFotoPreview = this.foto.activeFotoPendukungBase64
            this.$bvModal.show("modal-preview-foto")
			},
			async fetchMerkBarangByJenis() {
				const id = this.newLtv.jenisId
				
				this.stateMerkBarang.isLoading = true
				this.stateMerkBarang.error = null
				this.stateMerkBarang.data = []

				try {
					const res = await this.$axios.get(`barang-merk/jenis/${id}`);
					this.stateMerkBarang.data = res.data
				} catch (error) {
					this.stateMerkBarang.error =
						error.response.data.reason ||
						error.response.data.error ||
						'Terjadi kesalahan'
				} finally {
					this.stateMerkBarang.isLoading = false
				}
			},
			validateAddLtv() {
				if (this.$helper.isNullOrEmpty(this.newLtv.jenisId)) {
					this.$helper.toastErr(this, "Mohon pilih jenis.")
					return true
				}

				if (this.$helper.isNullOrEmpty(this.newLtv.persen)) {
					this.$helper.toastErr(this, "Mohon isi persen.")
					return true
				}

				return false
			},
			getPercentageValue() {
				return this.$axios.get('harga-emas/current-persentase').then(response => {
					this.dataPercentageValue = response.data.id
				})
			}
    },
	
    created(){
        this.init()
		this.fetchLtvList()
		this.fetchJenisEmas()
		this.getPresignedUrl()
    }
}
</script>

<style scoped>
.browse-foto {
    position: relative;
}

.browse-foto .custom-file {
    opacity: 0;
    z-index: 1;
}

.browse-foto .custom-file .custom-file-input {
    z-index: 0;
}

.browse-foto .custom-file .custom-file-label {
    cursor: pointer;
}

.browse-foto button {
    position: absolute;
    top: 0;
    left: 0;
}

.browse-foto {
    margin-right: 10px;
}
</style>
